import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import boletoApi from 'app/services/api/boletoApi';
import * as Actions from 'app/store/actions';
import { getIdUserToken } from 'app/utils/enviromentUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ArquivoRetornoForm from './ArquivoRetornoForm';
import ArquivoRetornoSchema from './ArquivoRetornoSchema';

const initialValues = {
  arquivo: undefined,
  nomeArquivo: undefined,
  registroOcorrencia: [],
  progress: 0,
};

const ArquivoRetornoModal = (props) => {
  const { openModal, onCloseModal } = props;
  const [uuidLeitura, setUuidLeitura] = useState(getIdUserToken()); // código do cliente
  const [listener, setListener] = useState(false);
  const [loading, setLoading] = useState(false);

  useReduxLoading(loading);

  useEffect(() => {
    if (openModal) {
      setUuidLeitura(getIdUserToken());

      formik.resetForm(initialValues);
    }
    // Efeito de sincronia do formulário: manter apenas o gatilho evita reset em loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const dispatch = useDispatch();

  const apiUtils = useApiUtils(dispatch, Actions);

  const onSubmitForm = (values) => {
    if (values.arquivo) {
      const nomeArquivo = values.arquivo.name.split('.');

      // RNE-346: O sistema deve processar apenas arquivos com extensão .RET.
      if (nomeArquivo.length < 2 || nomeArquivo[1].toLowerCase() !== 'ret') {
        dispatch(
          Actions.showMessage({
            message: 'O formato do arquivo enviado é inválido. Favor informar um arquivo com extensão .RET.',
            variant: 'error',
          })
        );
      } else {
        try {
          setListener(true);
          setLoading(true);

          const reader = new FileReader();
          reader.readAsBinaryString(values.arquivo);

          reader.onload = async () => {
            try {
              const formData = new FormData();
              formData.append('arquivoRetorno', values.arquivo);

              const response = await boletoApi.processarArquivoRetorno(formData, uuidLeitura);

              // Atualiza tabela com lista de registros
              formik.handleChange({
                target: {
                  id: 'registroOcorrencia',
                  value: response.data,
                },
              });

              setLoading(false);
            } catch (error) {
              setLoading(false);
              apiUtils.handleApiError(error);
            }
          };
        } catch (error) {
          setLoading(false);
          apiUtils.handleApiError(error);
        }
      }
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit: onSubmitForm,
    validationSchema: ArquivoRetornoSchema,
    validateOnChange: true,
  });

  return (
    <SimpleDialog open={openModal} onClose={onCloseModal} innerScroll>
      <FormikProvider value={formik}>
        {openModal && (
          <FormDialogContent
            onSubmit={formik.handleSubmit}
            header={{
              title: 'Processar arquivo retorno',
              toolbar: (
                <>
                  <CancelButton title="cancelar" type="button" onClick={onCloseModal}>
                    Fechar
                  </CancelButton>
                  <SaveButton color="buttonSave">Processar</SaveButton>
                </>
              ),
            }}
            content={
              <div className="h-full max-h-full w-full">
                <ArquivoRetornoForm dispatch listener={listener} setListener={setListener} uuidLeitura={uuidLeitura} />
              </div>
            }
          />
        )}
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ArquivoRetornoModal;
